import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueResource from "vue-resource";
import Cookies from "js-cookie";
import VueScrollTo from "vue-scrollto";

Vue.config.productionTip = false;

Vue.use(VueResource);
Vue.use(VueScrollTo);

if (process.env.VUE_APP_BACKEND_HOST) {
  Vue.http.options.root = process.env.VUE_APP_BACKEND_HOST;
} else {
  Vue.http.options.root =
    window.location.origin + process.env.VUE_APP_BACKEND_SUB_PATH;
}
Vue.http.headers.common["X-CSRFToken"] = Cookies.get("csrftoken");
if (process.env.VUE_APP_BACKEND_AUTHORIZATION_TOKEN) {
  Vue.http.headers.common["Authorization"] =
    "Basic " + process.env.VUE_APP_BACKEND_AUTHORIZATION_TOKEN;
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
